import Swal from 'sweetalert2';

// Configuración global para SweetAlert2 con tema oscuro
export const SwalDark = Swal.mixin({
    background: '#1f2937',
    color: '#fff',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#dc3545',
    customClass: {
        popup: 'swal-dark-popup',
        title: 'swal-dark-title',
        content: 'swal-dark-content',
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-danger'
    }
});

// Función helper para mostrar alertas con tema oscuro
export const showAlert = (options) => {
    return SwalDark.fire(options);
};

// Alertas predefinidas
export const alerts = {
    success: (title, text) => SwalDark.fire({
        icon: 'success',
        title: title || 'Éxito',
        text: text || 'Operación completada correctamente',
        timer: 2000
    }),
    
    error: (title, text) => SwalDark.fire({
        icon: 'error',
        title: title || 'Error',
        text: text || 'Ha ocurrido un error'
    }),
    
    warning: (title, text) => SwalDark.fire({
        icon: 'warning',
        title: title || 'Advertencia',
        text: text
    }),
    
    confirm: (title, text) => SwalDark.fire({
        icon: 'question',
        title: title || '¿Estás seguro?',
        text: text || 'Esta acción no se puede deshacer',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar'
    })
};

export default SwalDark;